/* Beat Pulse ism.css `input[type]` resets (higher specificity). */
.input,
.input[type] {
  box-sizing: border-box;
  width: 100%;
  font-family: inherit;
  font-size: var(--ism-font-size-body-l);
  margin: 0;
  border: 1px solid var(--ism-color-outline);
  border-radius: var(--ism-radius-s);
  background-color: var(--ism-color-surface);
  padding: var(--ism-spacing-m);
  max-width: none;
  height: auto;
  line-height: 1;
  color: var(--ism-color-primary);
}

/* Placeholder */
.input::placeholder,
.input[type]::placeholder {
  color: var(--ism-color-on-surface-variant);
  font-size: inherit;
}

/* Hover */
.input[data-hovered]:not([data-disabled]):not([data-invalid]),
.input:hover:not(:disabled):not([data-invalid]),
.input[type][data-hovered]:not([data-disabled]):not([data-invalid]),
.input[type]:hover:not(:disabled):not([data-invalid]) {
  border-color: var(--ism-color-primary);
}

/* Focus */
.input[data-focused],
.input:focus,
.input[type][data-focused],
.input[type]:focus {
  border-color: var(--ism-color-focused);
}

.input:focus-visible,
.input[type]:focus-visible {
  outline-color: var(--ism-color-focused);
}

/* Invalid */
.input[data-invalid],
.input[type][data-invalid],
.input[aria-invalid="true"],
.input[type][aria-invalid="true"] {
  border: 2px solid var(--ism-color-error);
  background-color: var(--ism-color-error-container);
  color: var(--ism-color-error);
}

/* Disabled */
.input[data-disabled],
.input:disabled,
.input[type][data-disabled],
.input[type]:disabled {
  background-color: transparent;
  opacity: 0.5;
  outline-color: var(--ism-color-outline-variant);
  cursor: not-allowed;
}

/* Search input — composes the base styles, then adds overrides */
.searchInput {
  composes: input;
}
.searchInput::-webkit-search-cancel-button,
.searchInput::-webkit-search-decoration {
  -webkit-appearance: none;
}
.searchInput[type="search"] {
  padding-inline-start: var(--ism-spacing-3xl);
}
